import { POSITIONS } from "@/lib/jobs";

const Pick = ({ testId, value, options, onChange, none }) => (
  <select data-testid={testId} className="field-input flex-1 min-w-0" value={value || ""} onChange={(e) => onChange(e.target.value || null)}>
    <option value="">{none}</option>
    {options.map((p) => <option key={p} value={p}>{p}</option>)}
  </select>
);

export const ThrowEditor = ({ fielder, throws, onChange }) => {
  const first = throws.find((t) => t.order === 0)?.dst;
  const second = throws.find((t) => t.order === 1)?.dst;
  const set = (a, b) =>
    onChange(a ? [{ src: fielder, dst: a, order: 0 }, ...(b ? [{ src: a, dst: b, order: 1 }] : [])] : []);
  return (
    <div className="space-y-1.5">
      <span className="ctl-label">Throws from {fielder}</span>
      <div className="flex gap-2 items-center">
        <Pick testId="throw-first-select" value={first} none="No throw" options={POSITIONS.filter((p) => p !== fielder)} onChange={(v) => set(v, v ? second : null)} />
        <span className="font-bold">→</span>
        <Pick testId="throw-second-select" value={second} none="Then: none" options={POSITIONS.filter((p) => p !== first)} onChange={(v) => set(first, v)} />
      </div>
    </div>
  );
};
